import React from 'react';
import MarketDashboard from '../components/MarketDashboard';

export default function MarketPage({ marketData, topGainers, topLosers, mostActive, onNavigate, isLoggedIn, onSignIn, onRequestInvite }) {
  return (
    <div>
      <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h1 style={{ fontSize: '1.4rem', fontWeight: 900, color: '#f8fafc',
            margin: '0 0 0.25rem', letterSpacing: '-0.02em' }}>
            Market Overview
          </h1>
          <p style={{ fontSize: '0.8rem', color: '#475569', margin: 0 }}>
            US equities · Data delayed 15 min · Not investment advice
          </p>
        </div>
        {/* Screener CTA — natural next step after reviewing market conditions */}
        <button
          onClick={() => onNavigate && onNavigate('screener')}
          style={{
            display: 'flex', alignItems: 'center', gap: '0.5rem',
            padding: '0.55rem 1.1rem', borderRadius: '8px', cursor: 'pointer',
            background: 'rgba(99,102,241,0.12)', border: '1px solid rgba(99,102,241,0.35)',
            color: '#818cf8', fontSize: '0.82rem', fontWeight: 700,
            fontFamily: 'inherit', transition: 'all 0.15s', whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.22)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.6)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.12)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.35)'; }}
        >
          🔍 Screen Signals →
        </button>
      </div>
      <MarketDashboard
        marketData={marketData}
        topGainers={topGainers}
        topLosers={topLosers}
        mostActive={mostActive}
        onNavigate={onNavigate}
        isLoggedIn={isLoggedIn}
        onSignIn={onSignIn}
        onRequestInvite={onRequestInvite}
      />
    </div>
  );
}
